<ng-container *ngIf="previousSearches$ | async as previousSearches">
  <div *ngIf="previousSearches.length > 0" data-test-previous-searches>
    <h3
      id="previous-searches-title"
      class="grey-50-bg rounded-small pr-large-x ps-medium-y font-body-1 nordic-blue-900-text"
    >
      {{ 'bookingSearch.previousSearches' | finLocalization }}
    </h3>

    <ul
      [attr.id]="'previousSearches'"
      class="flex flex--column"
      tabindex="-1"
      role="listbox"
      aria-labelledby="previous-searches-title"
    >
      <li
        *ngFor="let search of previousSearches; let last = last; let index = index"
        class="flex flex--middle flex--space-between focus-inset link-hover pr-large-x"
        [class.border-bottom]="!last"
        [attr.aria-label]="'previousSearch-' + index"
        role="option"
        data-test-previous-search-item
      >
        <div class="flex flex--column ps-medium-y" (click)="setSearch(search)" data-test-previous-search-set-item>
          <div class="font-body-1 capitalize location-title">
            <div *ngIf="search" class="flex fill">
              <span class="ps-xxsmall-r overflow-hidden truncate">{{ search?.origin?.cityName }}</span>
              <span
                >({{
                  search?.origin?.locationCode && search?.origin?.type === 'airport'
                    ? search?.origin?.locationCode
                    : ('bookingSearch.allAirportsLabel' | finLocalization)
                }})</span
              >
              <span> - {{ search?.destination?.cityName }}</span>
              <span
                >({{
                  search?.destination?.locationCode && search?.destination?.type === 'airport'
                    ? search?.destination?.locationCode
                    : ('bookingSearch.allAirportsLabel' | finLocalization)
                }})</span
              >
            </div>
          </div>
          <div class="font-body-2 ps-xxsmall-y nordic-blue-900-text">
            {{ search?.travelDates?.departureDate | finDateFormat: 'DATE' }}
            <span *ngIf="search?.travelDates?.returnDate">
              - {{ search?.travelDates?.returnDate | finDateFormat: 'DATE' }}</span
            >
          </div>
        </div>

        <button
          (click)="removePreviousSearchIndex$.next(index)"
          title="{{ 'actions.remove' | finLocalization }}"
          [attr.aria-controls]="'remove-previous-search-' + index"
          data-test-remove-previous-search-button
        >
          <fcom-icon name="trash" class="is-xsmall"></fcom-icon>
        </button>
      </li>
    </ul>
  </div>
</ng-container>
